export function formatDecimalPrecision(value: number, minFractionDigits: number = 2, maxFractionDigits: number = 10): string {
  return Intl.NumberFormat('en-US', {
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  }).format(value);
}

export function formatCentsToDollars(cents?: number): number {
  return !!cents && cents >= 0 ? cents / 100 : 0;
}

export function formatDollarsToCents(cents?: number): number {
  return !!cents && cents >= 0 ? cents * 100 : 0;
}

export function formatPricingToDollars(millicents?: number): number {
  return !!millicents && millicents >= 0 ? millicents / (1000 * 100) : 0;
}

export function formatPricingPerMillionToken(millicentPerToken?: number): string {
  const dollarAmountPerToken = formatPricingToDollars(millicentPerToken);
  const dollarAmountPerMillionToken = dollarAmountPerToken * 1000000;
  const finalAmount = formatDecimalPrecision(dollarAmountPerMillionToken);

  if (dollarAmountPerMillionToken < 0) {
    return '';
  }

  return finalAmount;
}

export function formatPricingPerSecond(millicents: number, precision?: number) {
  const dollarAmount = formatPricingToDollars(millicents);

  if (precision) {
    return dollarAmount.toFixed(precision);
  }

  return dollarAmount;
}

export function formatPricingPerHour(millicents: number, precision?: number) {
  return formatPricingPerSecond(millicents * 3600, precision);
}

export function mibToGib(mib: number) {
  if (Number(mib) === 0) return 0;

  return Number(mib) / 1024;
}
